import { render, staticRenderFns } from "./Zhindependence.vue?vue&type=template&id=4f973d4a&scoped=true"
import script from "./Zhindependence.vue?vue&type=script&lang=js"
export * from "./Zhindependence.vue?vue&type=script&lang=js"
import style0 from "./Zhindependence.vue?vue&type=style&index=0&id=4f973d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f973d4a",
  null
  
)

export default component.exports